// Renames the next thread this agent element reports, once the SDK confirms its (server-persisted) uid.
// Shared by every surface that opens a thread with a specific title.
export function renameNextThread(agentEl, threadTitle) {
  if (!threadTitle) return;
  agentEl === null || agentEl === void 0 || agentEl.addEventListener('mindset:thread-changed', function (e) {
    var threadUid = e.detail.threadUid;
    if (threadUid) {
      var _agentEl$renameThread;
      agentEl === null || agentEl === void 0 || (_agentEl$renameThread = agentEl.renameThread) === null || _agentEl$renameThread === void 0 || _agentEl$renameThread.call(agentEl, threadUid, threadTitle);
    }
  }, {
    once: true
  });
}